import { Link } from 'react-router-dom';
import FooterAts from './FooterAts';
import HeaderATS from './HeaderAts';
import ats from './data';

function AboutPage() {

  const { team } = ats;

  return (
    <div className="page">
      <HeaderATS />
      
      <main className="isolate">
        {/* Hero section */}
        <div className="relative isolate -z-10">
          <svg
            aria-hidden="true"
            className="absolute inset-x-0 top-0 -z-10 h-[64rem] w-full stroke-gray-200 [mask-image:radial-gradient(32rem_32rem_at_center,white,transparent)]"
          >
            <defs>
              <pattern
                x="50%"
                y={-1}
                id="1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84"
                width={200}
                height={200}
                patternUnits="userSpaceOnUse"
              >
                <path d="M.5 200V.5H200" fill="none" />
              </pattern>
            </defs>
            <svg x="50%" y={-1} className="overflow-visible fill-gray-50">
              <path d="M-200 0h201v201h-201Z M600 0h201v201h-201Z M-400 600h201v201h-201Z M200 800h201v201h-201Z" strokeWidth={0} />
            </svg>
            <rect fill="url(#1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84)" width="100%" height="100%" strokeWidth={0} />
          </svg>
          <div
            aria-hidden="true"
            className="absolute left-1/2 right-0 top-0 -z-10 -ml-24 transform-gpu overflow-hidden blur-3xl lg:ml-24 xl:ml-48"
          >
            <div
              style={{
                clipPath:
                  'polygon(63.1% 29.5%, 100% 17.1%, 76.6% 3%, 48.4% 0%, 44.6% 4.7%, 54.5% 25.3%, 59.8% 49%, 55.2% 57.8%, 44.4% 57.2%, 27.8% 47.9%, 35.1% 81.5%, 0% 97.7%, 39.2% 100%, 35.2% 81.4%, 97.2% 52.8%, 63.1% 29.5%)',
              }}
              className="aspect-[801/1036] w-[50.0625rem] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30"
            />
          </div>
          <div className="overflow-hidden">
            <div className="mx-auto max-w-7xl px-6 pb-12 pt-36 sm:pt-60 lg:px-8 lg:pt-32">
              <div className="mx-auto max-w-2xl gap-x-14 lg:mx-0 lg:flex lg:max-w-none lg:items-center">
                <div className="w-full max-w-xl lg:shrink-0 xl:max-w-2xl">
                  <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
                  Find Your Perfect Ride
                  </h1>
                  <p className="relative mt-6 text-lg leading-8 text-gray-600 sm:max-w-md lg:max-w-none">
                  At ATS Auto Detail &amp; Sales, we take pride in hand-selecting every vehicle as if we were choosing it for our own family. We offer a range of dependable, well-maintained used cars that fit any budget and lifestyle. Whether you’re looking for a safe family SUV, an economical sedan, or something a little more special, our goal is to help you find the right vehicle at the right price. Come browse our inventory, and let us help you drive home with confidence.</p>
                  <div className="mt-10 flex items-center gap-x-6">
                    <Link to="/inventory"
                      className="rounded-md bg-red-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Find your next car <span aria-hidden="true">→</span>
                    </Link>
                  </div>
                </div>
                <div className="mx-auto mt-16 flex max-w-2xl sm:mt-24 lg:ml-10 lg:mr-0 lg:mt-0 lg:max-w-none lg:flex-none xl:ml-32">
                  <div className="max-w-3xl flex-none sm:max-w-5xl lg:max-w-none">
                    <img
                      alt={ats.stock_img[2].alt}
                      src={ats.stock_img[2].url}
                      width={2432}
                      height={1442}
                      className="w-[76rem] rounded-md bg-white/5 shadow-2xl ring-1 ring-white/10"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* Team section */}
        <div className="mx-auto mt-32 max-w-7xl px-6 sm:mt-48 lg:px-8">
          <div className="mx-auto max-w-2xl lg:mx-0">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Meet our team</h2>
            <p className="mt-6 text-lg leading-8 text-gray-600">
            <strong>ATS Auto Detail &amp; Sales, LLC</strong> is a small family-owned and operated dealership, dedicated to provide our customers with fair prices, and great customer service. Our friendly sales staff is here to help you find the car you deserve, priced to fit your budget, style, and needs. Check out our inventory of used cars, trucks and SUVs online, then schedule an appointment to take your next car for a test drive.
            </p>
          </div>
          <ul className="mx-auto mt-20 grid max-w-2xl grid-cols-2 gap-x-8 gap-y-16 text-center sm:grid-cols-3 md:grid-cols-4 lg:mx-0 lg:max-w-none lg:grid-cols-3 xl:grid-cols-4"
          >{team.map((person) => (
              <li key={person.name}>
                <img alt={person.name + ' picture'} src={person.imageUrl} className="mx-auto h-24 w-24 rounded-full" />
                <h3 className="mt-6 text-base font-semibold leading-7 tracking-tight text-gray-900">{person.name}</h3>
                <p className="text-sm leading-6 text-gray-600">{person.role}<br/>
                {person.role2 ? person.role2 : null}</p>
              </li>
            ))}
          </ul>
        </div>


        {/* Content section */}
        <div className="mt-32 overflow-hidden sm:mt-40">
          <div className="mx-auto max-w-7xl px-6 lg:flex lg:px-8">
            <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-12 gap-y-16 lg:mx-0 lg:min-w-full lg:max-w-none lg:flex-none lg:gap-y-8">
              <div className="lg:col-end-1 lg:w-full lg:max-w-lg lg:pb-8">
                <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl mb-4">Why Choose ATS Auto?</h2>
                <div className="text-xl leading-8 text-gray-800">
                  <h4 className='text-xl font-bold italic'>Transparency:</h4>
                  <p>No hidden fees, no surprises—just honest pricing.</p>
                  <br/>
                  <h4 className='text-xl font-bold italic'>Customer Satisfaction:</h4>
                  <p>Our goal is to make sure you drive away happy, every time.</p>
                    <br/>
                    <h4 className='text-xl font-bold italic'>Affordability:</h4>
                  <p>We want to provide every customer with a vehicle that matches their needs, at a fair market price.  We want you to feel confident with your purchase.</p>
                </div>
              </div>
              <div className="block sm:flex flex-wrap items-start justify-end gap-6 sm:gap-8 lg:contents">
                <div className="w-0 sm:flex-auto lg:ml-auto lg:w-auto lg:flex-none lg:self-end">
                  <img alt={ats.stock_img[0].alt} src={ats.stock_img[0].url} className="aspect-[7/5] w-[37rem] max-w-none rounded-2xl bg-gray-50 object-cover" />
                </div>
                <div className="contents lg:col-span-2 lg:col-end-2 lg:ml-auto lg:flex lg:w-[37rem] lg:items-start lg:justify-end lg:gap-x-8">
                  <div className="hidden lg:flex w-96 flex-auto justify-end lg:w-auto lg:flex-none">
                    <img alt={ats.stock_img[1].alt} src={ats.stock_img[1].url} className="aspect-[7/5] w-[37rem] max-w-none flex-none rounded-2xl bg-gray-50 object-cover" />
                  </div>
                  <div className="hidden lg:flex sm:w-0 sm:flex-auto lg:w-auto lg:flex-none">
                    <img alt={ats.stock_img[3].alt} src={ats.stock_img[3].url} className="aspect-[4/3] w-[24rem] max-w-none rounded-2xl bg-gray-50 object-cover" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <br/>
        <br/>

      </main>

      <FooterAts />
    </div>
  );
}

export default AboutPage;